import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "paginationContainer",
  class: "q-py-1"
}
const _hoisted_2 = {
  key: 0,
  class: "q-fw-normal q-text-secondary q-mb-0 q-text-center q-p-2"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { "aria-label": "Serp results navigation" }
const _hoisted_6 = { class: "q-pagination q-justify-content-center q-pe-2" }
const _hoisted_7 = {
  key: 0,
  class: "q-page-item q-shadow-sm q-rounded-3 q-go-to-first-button"
}
const _hoisted_8 = {
  key: 1,
  class: "q-page-item q-shadow-sm q-rounded-3 q-prev-button"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "q-page-item q-shadow-sm q-rounded-3 q-next-button"
}
const _hoisted_11 = { id: "smartSearchVersion" }

import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

import {storeToRefs} from "pinia";
import {onMounted, inject} from "vue";
import {useMobileViewStore} from "@/store/MobileViewStore";

import {SmartSearchTranslationsInterface} from "@/core/types";
import NextPageButton from "@/components/SerpPage/ResultsContainer/PaginationContainer/NextPageButton.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationContainer',
  props: ['position'],
  setup(__props) {

const serpStore = useSerpResultsStore()

const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

let {next, prev} = SmartSearchTranslations.value.pagination
let parser = new DOMParser;
let prevParser = parser.parseFromString('<!doctype html><body>' + prev, 'text/html');
let nextParser = parser.parseFromString('<!doctype html><body>' + next, 'text/html');
prev = prevParser.body.textContent;
next = nextParser.body.textContent;
const { VUE_APP_VERSION } = process.env;

const paginationStore = usePaginationStore();
const {getProductsCount} = storeToRefs(serpStore)

const {
  totalPage,
  page,
  getNextPage,
  getPreviousPage,
  getPages
} = storeToRefs(paginationStore)

onMounted(() => {
  page.value = usePaginationStore().getSelectedPageFromUrl()
  const mobileViewStore = useMobileViewStore()
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);
})


return (_ctx: any,_cache: any) => {
  return (_unref(getProductsCount) > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(totalPage) !== null && _unref(totalPage) <= 1 && _unref(getProductsCount) > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              (__props.position !=='top')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(SmartSearchTranslations).serp.showedAll), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(NextPageButton),
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  (_unref(page) > 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                        _createElementVNode("a", {
                          class: "q-page-link q-px-1",
                          href: "#",
                          tabindex: "-1",
                          "aria-disabled": "true",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(paginationStore).setActualPageValue(0)), ["prevent"]))
                        }, _toDisplayString('<<'))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(page) > 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createElementVNode("a", {
                          class: "q-page-link",
                          href: "#",
                          tabindex: "-1",
                          "aria-disabled": "true",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(paginationStore).setActualPageValue(_unref(getPreviousPage))), ["prevent"]))
                        }, _toDisplayString(_unref(prev)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getPages), (pageNumber) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["q-page-item q-shadow-sm q-rounded-3", { 'q-active': pageNumber ===  _unref(page) + 1 }]),
                      key: pageNumber
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["q-page-link", { 'q-active-link': pageNumber ===  _unref(page) + 1 }]),
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_unref(paginationStore).setActualPageValue(pageNumber - 1 )), ["prevent"])
                      }, _toDisplayString(pageNumber), 11, _hoisted_9)
                    ], 2))
                  }), 128)),
                  (_unref(page) + 1 < _unref(totalPage))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createElementVNode("a", {
                          class: "q-page-link",
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(paginationStore).setActualPageValue(_unref(getNextPage))), ["prevent"]))
                        }, _toDisplayString(_unref(next)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])),
        _createElementVNode("small", _hoisted_11, "Smart Search by QON version: " + _toDisplayString(_unref(VUE_APP_VERSION)), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})